import styled from "styled-components";

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 40px;
  color: #333333;
  margin-bottom: 15px;
  line-height: 1.3;
  @media(max-width: 768px) {
    font-size: 28px;
  }
`

export default SectionTitle